<div class="not-found-container">
  <lucide-icon name="Ghost" [size]="160" class="not-found-icon"></lucide-icon>
  <h1 class="title">404</h1>
  <p class="subtitle">{{ 'notFound.subtitle' | transloco }}</p>
  <app-button
    [label]="'notFound.backButton' | transloco"
    (onClick)="handleGoBack()"
    class="return-button"
  ></app-button>
</div>
